<template>
  <div>
    <div class="page-content">
      <div class="container"> 
        <div class="main-container">
          <div class="row">
            <div style="width: 100%;">
              <div class="containerm container-fh" id="transc_success">
                <div class="main-container container-fh__content p-trial-period-expired" style="padding: 0px;">
                  <img src="/static/img/modal/3.svg" v-if="TranscResp.status !== 'successful'" alt="" class="p-trial-period-expired__image" width="200px">
                  <img src="/static/img/modal/2.svg"  v-if="TranscResp.status === 'successful'"  alt="" class="p-trial-period-expired__image" width="200px">
                  <div>
                    <h2 class="p-trial-period-expired__heading">Transaction {{TranscResp.status}}!</h2>
                    <div class="p-trial-period-expired__desc">{{getUserSession.firstName + ' '+ getUserSession.lastName}}</div>
                    <div class="p-trial-period-expired__desc">{{getUserSession.phoneNumber}}</div>
                    <div class="p-trial-period-expired__desc" v-for="(single,index) in TranscResp.data" :key="index" v-if="index !== 'UserID'">{{`${index}: ${single}`}}</div>
                    <div class="p-trial-period-expired__desc">Date: </div> 
                    <div class="p-trial-period-expired__upgrade">
                      <a href="/" class="btn btn-info">Go back home</a>
                     </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";

export default {
  name: "manage-wallet",
  data() {
    return {
      TranscResp: {},
      responseData: "",
      errors: "",
      componentName: "",
      columns: [
        {
          label: "User",
          field: "user",
          filterable: true
        },
        {
          label: "Reference",
          field: "ref",
          filterable: true
        },
        {
          label: "Date",
          field: "date",
          filterable: true
        }
      ],
      rows: [
        { user: "300283377", ref: "2012020321", date: "12/12/2015" },
        { user: "305383177", ref: "2012020321", date: "12/01/1991" }
      ]
    };
  },
  methods: {
    random_num: dumm => {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal() {
      this.$refs.myModalRef.show();
    },
    hideModal() {
      this.$refs.myModalRef.hide();
    },
    processResponse() {
      var RESPONSE = window.location.href;
      var splited = RESPONSE.split("/");
      var splited = splited[splited.length - 1];
      // console.log(splited);
      var respData = JSON.parse(
        '{"' +
          decodeURI(splited.split("?")[1])
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"') +
          '"}'
      );
      respData.UserID = this.getUserSession.id;
      respData.status = splited.split("?")[0];
      var tempResult = {
        status: splited.split("?")[0],
        data: respData,
        UserID: this.getUserSession.id
      };
      this.TranscResp = tempResult;
      var transactionPayload = {
        transactionReference: tempResult.data.TransactionReference,
        orderId: tempResult.data.OrderID,
        status: tempResult.data.status
      };
      this.pushTransaction(transactionPayload);
    },
    pushTransaction(data) {
      const HTTP = this.$httpUtils.instance;
      const url = "/payments/fidelityPayGate";
      const container = this;
      HTTP.post(url, data)
        .then(response => {
          // container.$router.push({path: `/device/${response.data.data.inverter_number}`});
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  computed: {
    ...mapGetters(["getUserSession"])
  },
  mounted() {
    this.processResponse();
    // console.log(window.location.href);
  }
};
</script>
<style>
.widget_box {
  min-height: auto !important;
}
.modal-header {
  border-bottom-left-radius: 50% 20%;
  border-bottom-right-radius: 50% 20%;
  background: #ecf2f6;
  /* height: 100px; */
}
</style>




// WEBPACK FOOTER //
// src/components/pages/shs/TransactionResponse.vue